import { IMedia } from './media';

export type IAppExtended = Record<string, any>;

export type IApp<T extends IAppExtended = IAppExtended> = {
  id: 'app',
  brand: {
    name: string; // 'Mixer',
    businessName?: string; // 'Mixer Spa',
    appName?: string; // 'Mixer',
    logo?: IMedia; // { src: '/assets/Mixer.jpg' },
    email?: string; // 'info@websolute.it',
    telephone?: string; // '+39 0721 411112',
    address?: string; // 'Strada della Campanara, 15',
    city?: string; // 'Pesaro',
    provinceCode?: string; // 'PU',
    zipCode?: string; // '61122',
    countryCode?: string; // 'IT',
    twitterName?: string; // '@websolute',
    social: {
      key: string;
      url: string;
    }[];
  },
} & T;
